/**
 * Системные утилиты
 * @packageDocumentation
 */

/**
 * Ждать, пока условие истинно
 *
 * @param condition - функция, вычисляющая значение
 * @param period - период в мс между выполнениями condition()
 * @param timeout - максмальное время ожидания в мс
 */
export const waitWhile = (condition: Function, period: number = 10, timeout = 30_000) => {
	if (!condition()) return;

	return new Promise<void>((resolve, reject) => {
		const timerTimeout = setTimeout(() => {
			clearInterval(timer);

			reject('Condition is no resolve: timeout');
		}, timeout);

		const timer = setInterval(() => {
			if (!condition()) {
				clearTimeout(timerTimeout);
				clearInterval(timer);

				resolve();
			}
		}, period);
	});
};

/**
 * Приостановить выполнение кода
 *
 * @param delay - длительность паузы в мс
 */
export const sleep = (delay: number) => {
	return new Promise<void>((resolve) => {
		setTimeout(() => {
			resolve();
		}, delay);
	});
};

/**
 * Приостановить выполнение кода пока условие истинно
 * @param condition - функция, вычисляющая значение
 * @param delay - время задержки в мс
 * @param period - период в мс между выполнениями condition()
 */
export const sleepWhile = (condition: Function, delay: number = 300, period: number = 10) => {
	if (!condition()) return;

	return new Promise<void>(resolve => {
		const timerDelay = setTimeout(() => {
			clearInterval(timer);

			resolve();
		}, delay);

		const timer = setInterval(() => {
			if (!condition()) {
				clearTimeout(timerDelay);
				clearInterval(timer);

				resolve();
			}
		}, period);
	});
};
